export default __webpack_public_path__ + "static/media/emma-testimonial-selected.22b3d0fb.png";